<template>
    <section class="section a-section a-section--fullheight">
        <div class="container" v-if="advice">
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-label">Data załadunku</p>
                    <div class="a-flex a-flex--justifyContent-flexStart">
                        <icon-calendar class="a-icon--marginRight"/>
                        <div>
                            <p class="a-text a-text--title">
                                {{ loadingDate }}
                            </p>
                            <p class="a-text">
                                {{ advice.loading_hours }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-label">Data dostawy</p>
                    <div class="a-flex a-flex--justifyContent-flexStart">
                        <icon-calendar class="a-icon--marginRight"/>
                        <div>
                            <p class="a-text a-text--title">
                                {{ adviceDate }}
                            </p>
                            <p class="a-text">
                                {{ advice.hours }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-label">Tonaż</p>
                    <p class="a-text a-text--title a-flex a-flex--justifyContent-flexStart">
                        <icon-tonnage class="a-icon--marginRight"/>
                        {{ advice.tonnage }} t
                    </p>
                </div>
                <div class="column">
                    <p class="a-label">Nr Zlecenia</p>
                    <p class="a-text a-text--title">
                        {{ advice.ax_id }}
                    </p>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <p class="a-label">Produkt</p>
                    <p class="a-text a-text--title a-text--marginBottom">
                        {{ advice.product }}
                    </p>
                    <p class="a-text">
                        {{ advice.recipients.name }}
                    </p>
                    <br />
                    <button
                        class="button is-primary a-button a-button--main a-button--uppercase a-button--marginBottom a-flex"
                        @click="$router.push({ name: 'loading', params: { token } })"
                        v-if="$route.query.preview"
                    >
                        <span class="a-flex a-flex--flexDirection-column">
                            Powrót
                        </span>
                    </button>
                    <button
                        v-else
                        class="button is-primary a-button a-button--main a-button--uppercase a-button--marginBottom a-flex"
                        @click="$router.push({ name: 'unloading-photos', params: { token } })"
                    >
                        <icon-accept />
                        <span class="a-flex a-flex--flexDirection-column">
                            Towar rozładowany
                            <small>Kliknij, aby potwierdzić</small>
                        </span>
                    </button>
                    <GmapMap
                        v-if="recipientsPosition != null"
                        class="a-map"
                        :center="recipientsPosition"
                        :zoom="10"
                        ref="gmap"
                        :options="{
                            disableDefaultUI: true
                        }"
                    >
                        <GmapMarker
                            :position="recipientsPosition"
                            :clickable="true"
                            :draggable="false"
                            @click="center = recipientsPosition"
                        />
                    </GmapMap>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="a-text">
                        {{ advice.recipients.name }}<br />
                        {{ advice.recipients.address }}<br />
                        {{ advice.recipients.postcode }}, {{ advice.recipients.city }}<br />
                    </p>
                </div>
                <div class="column">
                    <a
                        class="button a-button a-button--uppercase"
                        :href="`http://maps.apple.com/?daddr=${advice.recipients.latitude},${advice.recipients.longitude}`"
                    >
                        <icon-pin />
                        Zaplanuj trasę
                    </a>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <hr class="a-hr a-hr--noMargin" />
                    <p class="a-label">
                        PIN
                    </p>
                    <p v-if="advice.pin">
                        {{ advice.pin }}
                    </p>
                    <p v-else>Brak</p>
                    <p class="a-label">
                        Notatka / instrukcja
                    </p>
                    <p>
                        {{ advice.instructions }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconCalendar from '@/components/icons/Calendar'
import IconTonnage from '@/components/icons/Tonnage'
import IconAccept from '@/components/icons/Accept'
import IconPin from '@/components/icons/Pin'
export default {
    name: 'Loading',
    components: {
        IconCalendar,
        IconTonnage,
        IconAccept,
        IconPin
    },
    computed: {
        advice() {
            return this.$store.getters.advice
        },
        token() {
            return this.$store.getters.token
        },
        adviceDate() {
            return this.$dayjs(this.advice.date).format('DD.MM.YYYY')
        },
        loadingDate() {
            return this.$dayjs(this.advice.loading_date).format('DD.MM.YYYY')
        },
        recipientsPosition() {
            return this.$store.getters.recipientsPosition
        }
    }
}
</script>
